import { Padding } from '@mui/icons-material';
import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(14, 0, 14, 0),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(8, 0),
  },
  '& .IBimgbox': {
    borderRadius: theme.spacing(0.5),
    overFlow: 'hidden',
  },
  '& .OAESImage': {
    position: 'relative',
    width: theme.typography.pxToRem(533),
    height: theme.typography.pxToRem(465),
    maxWidth: '100%',
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(490),
      marginBottom: theme.typography.pxToRem(200),
    },
    [theme.breakpoints.down('md')]: {
      width: '90%',
      height: theme.typography.pxToRem(291),
      marginBottom: theme.typography.pxToRem(233),
    },
  },
  '& .OAESSubImg': {
    position: 'absolute',
    width: theme.typography.pxToRem(304),
    height: theme.typography.pxToRem(259),
    bottom: theme.typography.pxToRem(-200),
    right: theme.typography.pxToRem(-40),
    [theme.breakpoints.down('lg')]: {
      height: theme.typography.pxToRem(244),
    },
    [theme.breakpoints.down('md')]: {
      width: theme.typography.pxToRem(256),
      height: theme.typography.pxToRem(259),
      right: '-10%',
      bottom: theme.typography.pxToRem(-233),
    },
  },
  '& .OAESListItem': {
    marginBottom: theme.spacing(2),
    display: 'flex',
    alignItems: 'flex-start',
    padding: 0,
  },
  '& .OAESIcon': {
    width: theme.spacing(3),
    height: theme.spacing(3),
    marginRight: theme.spacing(1),
    flex: '0 0 auto',
  },
  '& .OAESBenfites': {
    '& .highligtText': {
      color: theme.palette.common.white,
      fontWeight: 700,
    },
  },
}));

export default StyledBox;
